export default __webpack_public_path__ + "static/media/eimt-logo.9a60aa1d.webp";